import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AdvancedFilters, FilterState } from "@/components/AdvancedFilters";

const ALL_CATEGORIES = [
  { value: "Målning", label: "Målning" },
  { value: "Skulptur", label: "Skulptur" },
  { value: "Fotografi", label: "Fotografi" },
  { value: "Digital konst", label: "Digital konst" },
  { value: "Illustration", label: "Illustration" },
  { value: "Grafik", label: "Grafik" },
  { value: "Övrigt", label: "Övrigt" },
];

interface ExploreFiltersProps {
  category: string;
  setCategory: (value: string) => void;
  selectedArtist: string;
  setSelectedArtist: (value: string) => void;
  artworkType: "all" | "original" | "print";
  setArtworkType: (value: "all" | "original" | "print") => void;
  sortBy: string;
  setSortBy: (value: string) => void;
  advancedFilters: FilterState;
  setAdvancedFilters: (filters: FilterState) => void;
  artists: { id: string; username: string | null; full_name: string | null }[] | undefined;
  availableCategories: string[];
}

export function ExploreFilters({
  category,
  setCategory,
  selectedArtist,
  setSelectedArtist,
  artworkType,
  setArtworkType,
  sortBy,
  setSortBy,
  advancedFilters,
  setAdvancedFilters,
  artists,
  availableCategories,
}: ExploreFiltersProps) {
  const visibleCategories = ALL_CATEGORIES.filter(cat => 
    availableCategories.includes(cat.value)
  );

  return (
    <div className="mb-3 sm:mb-4 md:mb-8">
      <div className="grid grid-cols-2 gap-2 sm:gap-3 sm:flex sm:flex-row">
        <Select value={category} onValueChange={setCategory}>
          <SelectTrigger className="h-10 sm:h-12 text-sm sm:text-base">
            <SelectValue placeholder="Kategori" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Alla kategorier</SelectItem>
            {visibleCategories.map((cat) => (
              <SelectItem key={cat.value} value={cat.value}>
                {cat.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={selectedArtist} onValueChange={setSelectedArtist}>
          <SelectTrigger className="h-10 sm:h-12 text-sm sm:text-base">
            <SelectValue placeholder="Konstnär" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Alla konstnärer</SelectItem>
            {artists?.map((artist) => (
              <SelectItem key={artist.id} value={artist.id}>
                {artist.username || artist.full_name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={artworkType} onValueChange={(value: "all" | "original" | "print") => setArtworkType(value)}>
          <SelectTrigger className="h-10 sm:h-12 text-sm sm:text-base">
            <SelectValue placeholder="Typ" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Alla typer</SelectItem>
            <SelectItem value="original">Originalverk</SelectItem>
            <SelectItem value="print">Prints & Posters</SelectItem>
          </SelectContent>
        </Select>

        <Select value={sortBy} onValueChange={setSortBy}>
          <SelectTrigger className="h-10 sm:h-12 text-sm sm:text-base">
            <SelectValue placeholder="Sortera" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="popular">Populärast</SelectItem>
            <SelectItem value="newest">Nyast först</SelectItem>
            <SelectItem value="price_low">Pris: Låg till hög</SelectItem>
            <SelectItem value="price_high">Pris: Hög till låg</SelectItem>
          </SelectContent>
        </Select>

        <AdvancedFilters 
          onFiltersChange={setAdvancedFilters}
          initialFilters={advancedFilters}
        />
      </div>
    </div>
  );
}
